import { HTMLAttributeAnchorTarget, memo } from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

interface ILinkButton {
  variantType?: "default" | "secondary";
  path: string;
  label?: string;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
}
function LinkButton(props: ILinkButton) {
  const { variantType, path, label, target, className, disabled, onClick } = props;

  const getClassNames = () => {
    if (disabled) {
      return "!cursor-not-allowed !text-dark-neutral-gray-500";
    }

    if (variantType === "secondary") {
      return "text-primary-electron-blue-700 hover:text-primary-electron-blue-800 focus:text-primary-electron-blue-600 active:text-primary-electron-blue-600";
    }

    return "text-light-brand-blue-800 dark:text-dark-neutral-gray-900 hover:text-brand-blue-600 dark:hover:text-dark-neutral-gray-800 hover:underline focus:text-brand-blue-1000 dark:focus:text-dark-neutral-gray-1000 active:text-light-brand-blue-1000 dark:active:text-dark-neutral-gray-1000";
  };

  return (
    <Link
      to={path}
      target={target ?? "_self"}
      onClick={onClick}
      className={`text-sm leading-4 hover:underline ${getClassNames()} ${className ?? ""}`}
    >
      <Trans>{label}</Trans>
    </Link>
  );
}

export default memo(LinkButton);
